// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeroCarouselVariant1_wrapper__nczyZ","body":"HeroCarouselVariant1_body__keSn0"};